const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
let fallbackVisitor;
export function visitorId(storage) {
  if (!fallbackVisitor) fallbackVisitor = crypto.randomUUID();
  try {
    if (!storage) storage = globalThis.localStorage;
    const existing = storage.getItem('aaf-quote-visitor');
    if (UUID.test(existing || '')) return existing;
    storage.setItem('aaf-quote-visitor', fallbackVisitor);
  } catch { /* Private/blocked storage still permits a view notification. */ }
  return fallbackVisitor;
}

export function scheduleVisibleView(doc, send, timers = globalThis) {
  let timer;
  let sent = false;
  const onVisibility = () => {
    timers.clearTimeout(timer);
    if (!sent && doc.visibilityState === 'visible') {
      timer = timers.setTimeout(() => {
        if (sent || doc.visibilityState !== 'visible') return;
        sent = true;
        // Even browser/storage limitations must never affect the quote itself.
        try { send(); } catch { /* best effort */ }
      }, 2500);
    }
  };
  doc.addEventListener('visibilitychange', onVisibility);
  onVisibility();
  return () => {
    timers.clearTimeout(timer);
    doc.removeEventListener('visibilitychange', onVisibility);
  };
}
